export enum EFaqIconStyle {
    CARET = 'Caret',
    PLUS = 'Plus',
}

export enum EFaqIconPosition {
    L = 'L',
    R = 'R',
}
